export default __webpack_public_path__ + "static/media/home_publications_mobile.bb144fbb.png";